export enum Justify {
  center = "center",
  left = "left",
  right = "right",
  justified = "justified",
}

export enum Align {
  center = "center",
  top = "top",
  bottom = "bottom",
  justified = "justified",
}

interface IComponentStyle {
  justify?: Justify;
  align?: Align;
  height?: number;
  width?: number;
  absolutePosition?: {
    x: number;
    y: number;
  };
  calendar?: {
    hideSMTWTFS?: boolean,
    hideMonthYear?: boolean,
    hideDates?: boolean,
    defaultDayColo?: boolean,
    year: number;
    month: number;
    days: IVBMLDay
  }
}

interface IVBMLDay {
  [key: string]: number
}

interface IVBMLStyle {
  height?: number;
  width?: number;
}

export interface VBMLProps {
  [key: string]: any;
}

export interface IVBMLRawComponent {
  style?: IComponentStyle;
  rawCharacters?: number[][];
}

export interface IVBMLTemplateComponent {
  template: string;
  style?: IComponentStyle;
}

export type IVBMLComponent = IVBMLRawComponent | IVBMLTemplateComponent;

export interface IVBML {
  props?: VBMLProps;
  style?: IVBMLStyle;
  components: IVBMLComponent[];
}
